import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useAuth } from "../contexts/AuthContext";

export default function Header({ onSkin }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Nom affiché : nom complet, sinon la partie locale de l'email, sinon "Admin"
  const displayName = user?.name || user?.email?.split("@")[0] || "Administrateur";
  const roleLabel = user?.role === "admin" ? "Administrateur" : "Éditeur";
  const initial = displayName.charAt(0).toUpperCase();

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to="#"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    navigate("/login");
  };

  // Mode clair/sombre
  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem("skin-mode", skin);
      onSkin(skin);
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem("skin-mode");
      onSkin("");
    }
  };

  // Skin de la sidebar
  const sidebarSkin = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
  };

  return (
    <div className="header-main px-3 px-lg-4">
      {/* Bouton hamburger */}
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      {/* Barre de recherche → redirige vers /documents */}
      <div className="form-search me-auto">
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher un document…"
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.target.value.trim()) {
              navigate(`/documents?q=${encodeURIComponent(e.target.value.trim())}`);
              e.target.value = "";
            }
          }}
        />
        <i className="ri-search-line"></i>
      </div>

      {/* --- Dropdown Skin --- */}
     

      {/* --- Notifications simplifiées --- */}
     

      {/* --- Dropdown profil (utilise useAuth) --- */}
      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online cere-header-avatar">
            {initial}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3 cere-header-avatar cere-header-avatar--xl">
              {initial}
            </div>
            <h5 className="mb-1 text-dark fw-semibold">{displayName}</h5>
            <p className="fs-sm text-secondary mb-0">
              <i className="ri-shield-user-line me-1"></i>{roleLabel}
            </p>
            {user?.email && (
              <p className="fs-sm text-secondary mb-3">
                <i className="ri-mail-line me-1"></i>{user.email}
              </p>
            )}

            <nav className="nav">
              <Link to="/profile"><i className="ri-user-line"></i> Mon profil</Link>
              <Link to="/statistics"><i className="ri-bar-chart-box-line"></i> Statistiques</Link>
              <Link to="/categories"><i className="ri-price-tag-3-line"></i> Catégories</Link>
            </nav>
            <hr />
            <nav className="nav">
              <button
                onClick={handleLogout}
                className="nav-link text-danger border-0 bg-transparent text-start"
              >
                <i className="ri-logout-box-r-line"></i> Déconnexion
              </button>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}